import { render } from "./PagoCliente.vue?vue&type=template&id=a9d4a7b0&scoped=true"
import script from "./PagoCliente.vue?vue&type=script&lang=js"
export * from "./PagoCliente.vue?vue&type=script&lang=js"

import "./PagoCliente.vue?vue&type=style&index=0&id=a9d4a7b0&scoped=true&lang=scss"

import exportComponent from "C:\\laragon\\www\\fronted_sit_bolivia\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-a9d4a7b0"]])

export default __exports__